import * as types from '~/store/contact/contactType';

export const postContact = contact => {
  return {
    type: types.POST_CONTACT,
    contact,
  };
};

export const onSaveContactForm = fields => {
  return {
    type: types.CONTACT_FORM_SAVE_FIELD,
    payloads: fields,
  };
};

export const onChangeInputType = type => {
  return {
    type: types.CONTACT_FORM_CHANGE_TYPE,
    payloads: type,
  };
};

export const resetContactForm = () => {
  return {
    type: types.RESET_CONTACT_FORM_FIELD,
  };
};
